import HealthCheck from "./HealthCheck";
import RegisterToSearchEngines from "./RegisterToSearchEngines";
import SettingsPage from "./SettingsPage";
import Sitemap from "./Sitemap";
import SSLPage from "./SSLPage";

export const pages = {
  HealthCheck,
  RegisterToSearchEngines,
  SettingsPage,
  Sitemap,
  SSLPage,
};
